//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import file from '@/utils/file';
import { paymentRecordApi as _paymentRecordApi, operationRecordApi } from '@/api/enterprise';
import Vue from 'vue';
Vue.use(file);
import { getInvoiceClassName, getInvoiceText, getInvoiceType } from '@/libs/customer';
export default {
  name: 'InvoiceView',
  props: {
    formData: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  components: {
    ElImageViewer: function ElImageViewer() {
      return import('element-ui/packages/image/src/image-viewer');
    },
    invoicingDialog: function invoicingDialog() {
      return import('@/views/fd/invoice/components/invoicingDialog');
    }
  },
  data: function data() {
    return {
      tabIndex: '1',
      drawer: false,
      direction: 'rtl',
      isImage: false,
      srcList: [],
      delData: {},
      tableData: [],
      tabPosition: 'top',
      recordList: [],
      list: [],
      invoicingDialog: {}
    };
  },
  watch: {
    formData: {
      handler: function handler(nVal, oVal) {
        this.delData = nVal.data;
      },
      deep: true
    }
  },
  methods: {
    handleClose: function handleClose() {
      this.drawer = false;
      this.tabIndex = '1';
    },
    openBox: function openBox() {
      this.drawer = true;
    },
    // 开票
    handleInvoicing: function handleInvoicing() {
      this.invoicingDialog = {
        title: '开票审核',
        data: this.formData.data
      };
      this.$refs.invoicingDialog.openBox();
    },
    isOk: function isOk() {
      this.handleClose();
    },
    getInvoiceStatus: function getInvoiceStatus(status) {
      return getInvoiceText(status);
    },
    getInvoiceColor: function getInvoiceColor(status) {
      return getInvoiceClassName(status);
    },
    getInvoiceTitle: function getInvoiceTitle(id) {
      return getInvoiceType(id);
    },
    // 关联付款单
    paymentRecordApi: function paymentRecordApi() {
      var _this = this;
      var data = {
        invoice_id: this.delData.id,
        eid: this.delData.eid
      };
      _paymentRecordApi(data).then(function (res) {
        _this.tableData = res.data.list;
      });
    },
    // 获取操作记录
    operationRecord: function operationRecord() {
      var _this2 = this;
      operationRecordApi(this.formData.data.id).then(function (res) {
        _this2.recordList = res.data.list;
      });
    },
    handleClick: function handleClick(e) {
      if (this.tabIndex == 2) {
        this.paymentRecordApi();
      }
      if (this.tabIndex == 3) {
        this.operationRecord();
      }
    },
    handlePictureCardPreview: function handlePictureCardPreview(row) {
      this.srcList.push(row);
      this.isImage = true;
    },
    closeImageViewer: function closeImageViewer() {
      this.isImage = false;
      this.srcList = [];
    }
  }
};